import { EventEmitter, Injectable } from '@angular/core';

import { HubConnection } from '@microsoft/signalr';
import * as signalR from '@microsoft/signalr';
import { SignalRSubscriber } from '../core/models/live/signalr-subscriber';
import { LocalStorageKeys } from '../core/constants/local-storage-keys';
import { AppSettings } from './app.settings';

const reconnectionPattern = [0, 3000, 5000, 10000, 15000, 30000];

@Injectable()
export class SignalRService {

    private _hubConnection: HubConnection | undefined;
    private _startPromise: Promise<void> | undefined;
    signalReceived = new EventEmitter<SignalRSubscriber>();

    constructor(private settings: AppSettings) {
        this.buildConnection();
    }

    private buildConnection() {
        var authToken = JSON.parse(localStorage.getItem(LocalStorageKeys.OAUTH_TOKEN))._token;
        let host = `${this.settings.main_url}/hubs/citybikehub`;

        this._hubConnection = new signalR.HubConnectionBuilder()
            .withUrl(host, { accessTokenFactory: () => authToken })
            .withAutomaticReconnect(reconnectionPattern)
            .configureLogging(signalR.LogLevel.Critical)
            .build();

        // Registered once per connection instance (built once, in the constructor) so that
        // stopping and later restarting the connection can never register a second handler.
        this.registerSignalEvents();
    }

    public startConnection() {
        this.ensureStarted();
    }

    public stopConnection() {
        this._startPromise = undefined;
        this._hubConnection.stop().catch(err => console.error(err.toString()));
    }

    public SubscribeConnection(id) {
        this.ensureStarted()
            .then(() => this._hubConnection.invoke("Subscribe", id))
            .catch(error => {
                console.log(error);
            });
    }

    public UnSubscribeConnection(id) {
        this.ensureStarted()
            .then(() => this._hubConnection.invoke("Unsubscribe", id))
            .catch(error => {
                console.log(error);
            });
    }

    // Starts the hub connection at most once, and lets any caller (regardless of
    // whether a page-level component already started it) safely wait for it.
    private ensureStarted(): Promise<void> {
        if (!this._startPromise) {
            this._startPromise = this._hubConnection.start().catch(err => {
                console.error(err.toString());
                this._startPromise = undefined;
                throw err;
            });
        }
        return this._startPromise;
    }

    private registerSignalEvents() {
        this._hubConnection.on("BikeUpdate", (update: SignalRSubscriber) => {
            // console.log(update);
            this.signalReceived.emit(update);
        });
    }

}